import React from 'react';
import { Control } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';

interface Client {
  id: string;
  name: string;
}

interface ProfileFormData {
  full_name?: string;
  email?: string;
  phone?: string;
  department?: string;
  role?: string;
  client_id?: string;
  client_ids?: string[];
  avatar_url?: string;
}

interface ProfileClientFieldProps {
  control: Control<ProfileFormData>;
  clients: Client[];
}

export const ProfileClientField = ({ control, clients }: ProfileClientFieldProps) => {
  return (
    <FormField
      control={control}
      name="client_ids"
      render={({ field }) => {
        const currentClients = field.value || [];
        
        return (
          <FormItem>
            <FormLabel>Clientes (Multi-Cliente)</FormLabel>
            <div className="grid grid-cols-2 gap-2 max-h-32 overflow-y-auto border rounded-md p-3 bg-background">
              {clients.length === 0 ? (
                <div className="col-span-2 text-sm text-muted-foreground text-center py-2">
                  Nenhum cliente disponível
                </div>
              ) : (
                clients.map((client) => (
                  <div key={client.id} className="flex items-center space-x-2">
                    <Checkbox
                      id={`profile-client-${client.id}`}
                      checked={currentClients.includes(client.id)}
                      onCheckedChange={(checked) => {
                        let newClients;
                        if (checked) {
                          newClients = [...currentClients, client.id];
                        } else {
                          newClients = currentClients.filter(id => id !== client.id);
                        }
                        field.onChange(newClients);
                      }}
                    />
                    <label
                      htmlFor={`profile-client-${client.id}`}
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
                    >
                      {client.name}
                    </label>
                  </div>
                ))
              )}
            </div>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};